/*
 * ShiftDetailCardCancellation Messages
 *
 * This contains all the text for the ShiftDetailCardCancellation component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  description: {
    id: 'app.components.ShiftDetailCardCancellation.description',
    defaultMessage:
      'Cancelling the shift will cancel all active turns and block applications',
  },
  descriptionCanceled: {
    id: 'app.components.ShiftDetailCardCancellation.descriptionCanceled',
    defaultMessage:
      'This shift and all active turns are canceled and applications are disabled.',
  },
  title: {
    id: 'app.components.ShiftDetailCardCancellation.title',
    defaultMessage: 'Shift cancellation',
  },
  titleCanceled: {
    id: 'app.components.ShiftDetailCardCancellation.titleCanceled',
    defaultMessage: 'Shift canceled',
  },
});
